// Theory Tabs web component

if (!customElements.get("td-tabs")) {
    class TabComponent extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            this.setupEventListeners();
        }
    
        setupEventListeners() {
            let tabs = this.querySelectorAll(`.td-featured-collections__tab`);
            let buttons = this.querySelectorAll(`.td-featured-collections__selector`);
            let ctas = this.querySelectorAll(`.td-featured-collections__cta`);
        
            buttons.forEach((button) => {
                button.addEventListener("click", () => {
                    // Grab the IDs that will identify matching tabs & buttons  
                    let tabId = button.dataset.tab;
                    let buttonId = button.dataset.button;
                    let ctaId = button.dataset.cta;
                
                    // Loop through the tab elements
                    // If the ID matches set it as active, otherwise remove the active class
                    tabs.forEach(tab => {
                        if (tab.id === tabId) {
                            tab.classList.add('active');
                        } else {
                            tab.classList.remove('active');
                        }
                    });
                
                    // Loop through the button elements
                    buttons.forEach(button => {
                        if (button.id === buttonId) {
                            button.classList.add('active');
                        } else {
                            button.classList.remove('active');
                        }
                    });
                
                    // Loop through the ctas
                    ctas.forEach(cta => {
                        if (cta.id === ctaId) {
                            cta.classList.add('active');
                        } else {
                            cta.classList.remove('active');
                        }
                    }); 
                });
            });
        }
    }
    
    customElements.define('td-tabs', TabComponent);
}